import * as React from "react";

export default class check extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <svg
        className={this.props.className}
        width="20px"
        height="20px"
        viewBox="0 0 20 20"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns="http://www.w3.org/1999/xlink"
      >
        <g
          id="Artboard"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g id="Group-69" stroke="#66D990">
            <circle id="Oval-3" cx="10" cy="10" r="9.5"></circle>
            <polyline
              id="Path-11-Copy-4"
              points="6 10.0985989 8.93353926 13 15 7"
            ></polyline>
          </g>
        </g>
      </svg>
    );
  }
}
